import { memo } from 'react';

// Skeleton para o header do relatório de feedback
export const FeedbackHeaderSkeleton = memo(() => {
    return (
        <div className="rounded-3 mb-4">
            <div className="mb-3">
                <div style={{ width: '50%', height: '32px', backgroundColor: '#e9ecef', borderRadius: '4px', marginBottom: '8px', position: 'relative' }}>
                    <div className="skeleton-shimmer"></div>
                </div>
                <div style={{ width: '70%', height: '20px', backgroundColor: '#e9ecef', borderRadius: '4px', position: 'relative' }}>
                    <div className="skeleton-shimmer"></div>
                </div>
            </div>
        </div>
    );
});

FeedbackHeaderSkeleton.displayName = 'FeedbackHeaderSkeleton';

// Skeleton para a seção de filtros do feedback
export const FeedbackFiltrosSkeleton = memo(() => {
    return (
        <div className="card border-0 shadow-sm mb-3" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}>
            <div className="card-body p-3">
                <div className="row g-2 align-items-end">
                    <div className="col-md-4">
                        <div style={{ width: '40px', height: '16px', backgroundColor: '#e9ecef', borderRadius: '4px', marginBottom: '8px', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                        <div style={{ width: '100%', height: '38px', backgroundColor: '#e9ecef', borderRadius: '4px', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div style={{ width: '120px', height: '38px', backgroundColor: '#e9ecef', borderRadius: '4px', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                    </div>
                    <div className="col-md-4 d-flex gap-2 justify-content-end">
                        <div className="btn-group">
                            <div className="btn btn-outline-primary" style={{ width: '100px', height: '38px', backgroundColor: '#e9ecef', border: 'none', position: 'relative' }}>
                                <div className="skeleton-shimmer"></div>
                            </div>
                            <div className="btn btn-outline-primary" style={{ width: '100px', height: '38px', backgroundColor: '#e9ecef', border: 'none', position: 'relative' }}>
                                <div className="skeleton-shimmer"></div>
                            </div>
                            <div className="btn btn-outline-primary" style={{ width: '100px', height: '38px', backgroundColor: '#e9ecef', border: 'none', position: 'relative' }}>
                                <div className="skeleton-shimmer"></div>
                            </div>
                        </div>
                        <div className="btn btn-success" style={{ width: '120px', height: '38px', backgroundColor: '#e9ecef', border: 'none', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

FeedbackFiltrosSkeleton.displayName = 'FeedbackFiltrosSkeleton';

// Skeleton para card de gráfico
const FeedbackCardSkeleton = memo(() => {
    return (
        <div className="col-md-6">
            <div className="card h-100" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}>
                <div className="card-body">
                    <div style={{ width: '80%', height: '24px', backgroundColor: '#e9ecef', borderRadius: '4px', marginBottom: '24px', position: 'relative' }}>
                        <div className="skeleton-shimmer"></div>
                    </div>
                    <div style={{ height: '300px', backgroundColor: '#e9ecef', borderRadius: '4px', position: 'relative' }}>
                        <div className="skeleton-shimmer"></div>
                    </div>
                </div>
            </div>
        </div>
    );
});

FeedbackCardSkeleton.displayName = 'FeedbackCardSkeleton';

// Componente que renderiza múltiplos skeletons de cards
export const FeedbackCardsSkeletons = ({ count = 4 }) => {
    const skeletons = Array.from({ length: count }, (_, index) => (
        <FeedbackCardSkeleton key={`skeleton-feedback-card-${index}`} />
    ));

    return <>{skeletons}</>;
};

// Componente completo de skeleton para relatório de feedback
export const FeedbackSkeleton = ({ cardCount = 4 }) => {
    return (
        <div className="fade-in w-100 mt-3" style={{ marginBottom: '100px' }}>
            <FeedbackHeaderSkeleton />
            <FeedbackFiltrosSkeleton />
            <div className="row g-4">
                <FeedbackCardsSkeletons count={cardCount} />
            </div>
        </div>
    );
};

export default FeedbackSkeleton;
